import React from 'react'

export const ACCREDITED_DOCUMENT_STATUS_NONE = 'none'

// Keyed by transaction_identity.accredited_document_status. A null status means
// there is no accredited-investor record at all, which shows no badge.
const DOCUMENT_STATUS_BADGES = {
  [ACCREDITED_DOCUMENT_STATUS_NONE]: { text: 'No Docs', className: 'label' },
  uploaded: { text: 'Docs Submitted', className: 'label label-warning' },
  verified: { text: 'Docs Verified', className: 'label label-primary' },
  invalid: { text: 'Docs Invalid', className: 'label label-danger' },
}

const BooleanBadge = ({ isTrue, accreditedDocumentStatus }) => {
  const badge = Object.prototype.hasOwnProperty.call(DOCUMENT_STATUS_BADGES, accreditedDocumentStatus)
    ? DOCUMENT_STATUS_BADGES[accreditedDocumentStatus]
    : null

  // "No Docs" is only worth showing for someone claiming to be accredited.
  const showBadge = badge && (accreditedDocumentStatus !== ACCREDITED_DOCUMENT_STATUS_NONE || Boolean(isTrue))

  return (
    <div>
      <i className={isTrue ? 'fa fa-check' : 'fa fa-minus'} />
      {showBadge && (
        <span style={{ marginLeft: 10 }} className={`${badge.className} text-uppercase`}>
          {badge.text}
        </span>
      )}{' '}
    </div>
  )
}

export default BooleanBadge
